export default __webpack_public_path__ + "static/media/53.52938f49.jpg";